<template>
  <div id="landing_redeem">
    <redeem-2fa
      v-if="!authorized"
      @getOptStatus="getOtpStatus"
      @switchMode="switchMode()"
    ></redeem-2fa>
    <!-- <withdraw-step-start
      v-if="step == 'start' && authorized"
      @callFirstStep="callFirstStep"
    />
    <withdraw-step0
      v-if="step == 1 && authorized"
      @callNext="callStepSelect"
      @switchMode="switchMode()"
    ></withdraw-step0>
    <withdraw-step02
      v-if="step == 2 && authorized"
      @callNext="callStepConfirmation"
      @switchMode="switchMode()"
    ></withdraw-step02> -->

    <withdraw-step03
      v-if="step == 3 && authorized"
      @backToPartners="backToPartners"
      @callNext="callStepPreview"
      :setAmount="this.withdraw.amount"
      :selectedPartner="this.selectedPartner"
      @switchMode="switchMode()"
      :selectedBlue="selectedBlue"
    ></withdraw-step03>

    <!-- <withdraw-step1 v-if="step == 2 && authorized" @callNext="callStepPreview"></withdraw-step1> -->
    <withdraw-step2
      v-if="step == 4"
      @callNext="callStepWithdraw"
      @resetStep="setFirstStep"
      :previewData="previewData"
      :address="address"
      :externalId="externalId"
      :selectedBlue="selectedBlue"
    ></withdraw-step2>

    <withdraw-step3
      v-if="step == 5"
      @confirmWithdraw="withdrawConfirm"
      @cancelRedeem="resetRedeem"
      :withdrawData="withdrawData"
      :selectedBlue="selectedBlue"
      @callWithdrawUsdt="callWithdrawUsdt"
      :address="address"
    ></withdraw-step3>
    
    <withdraw-step4
      v-if="step == 6"
      :withdrawData="withdrawData"
      :selectedBlue="selectedBlue"
    ></withdraw-step4>

    <withdraw-step9
      v-if="step == 9 && authorized"
      @resetStep="setFirstStep"
      :error="error"
      :dayEnabled="redeemInfo.dayAllowed"
    ></withdraw-step9>
  </div>
</template>
<script>
import Redeem2fa from "./redeem_steps/Redeem2fa";
import WithdrawStep0 from "./withdraw_steps/WithdrawStep0";
import WithdrawStep02 from "./withdraw_steps/WithdrawStep02";
import WithdrawStep03 from "./withdraw_steps/WithdrawStep03";
import WithdrawStep1 from "./withdraw_steps/WithdrawStep1";
import WithdrawStep2 from "./withdraw_steps/WithdrawStep2";
import WithdrawStep3 from "./withdraw_steps/WithdrawStep3";
import WithdrawStep4 from "./withdraw_steps/WithdrawStep4";
import WithdrawStep9 from "./withdraw_steps/WithdrawStep9";

import WithdrawStepStart from "./withdraw_steps/WithdrawStepStart";

import { mapGetters } from "vuex";
import { cryptoInput } from "../../../configs/global.js";

export default {
  created() {
    this.getOtpStatus();

    // this.getWithdraws();
  },
  props: ["selectedBlue", "step"],
  mounted() {},
  data: () => ({
    amountToSend: "",
    addressToSend: "",
    withdraws: "",
    redeemInfo: "",
    previewData: "",
    withdrawData: "",
    address: "",
    externalId: "",
    authorized: "",
    error: "",
    feeRedeem: "",
    preview: {
      targetAmount: "",
      sourceCurrency: "BLU",
    },
    type: "withdraw",
    withdraw: {
      amount: "",
      address: "",
      currency: "BLU",
      externalId: "",
    },
    selectedPartner: "",
  }),
  components: {
    Redeem2fa,
    WithdrawStep0,
    WithdrawStep02,
    WithdrawStep03,
    WithdrawStep1,
    WithdrawStep2,
    WithdrawStep3,
    WithdrawStep4,
    WithdrawStep9,
    WithdrawStepStart,
  },
  methods: {
    async getWithdraws() {
      let resp = await this.$store.dispatch("getTransactionsByType", this.type);
      if (resp.status == 200) {
        this.withdraws = resp.data;
      } else {
        console.log("no withdraws");
      }
    },

    checkRunningWithdraws() {
      let withdraws = this.withdraws;
      let openWithdraws = [];

      for (let i in withdraws) {
        if (withdraws[i].status == "new") {
          openWithdraws.push(withdraws[i]);
        }
      }
      console.log(openWithdraws);
      // alert('open withdraws:'+ openWithdraws.length);

      if (openWithdraws.length > 0) {
        for (let i in openWithdraws) {
          this.cancelOpenWithdraws(openWithdraws[i].id);
        }
      }
    },

    callFirstStep() {
      this.step = 3;
    },

    async cancelOpenWithdraws(id) {
      let body = {
        e2faCode: "000000",
        id: id,
        pinCode: "000000",
      };

      for (let i = 0; i < 3; i++) {
        let resp = await this.$store.dispatch("putWithdrawConfirm", body);
      }
    },

    async callWithdrawUsdt() {
      let payload = {
        address: this.usdtAccount.address,
        addressTo: this.addressToSend,
        amount: this.amountToSend,
        currency: "USDT",
      };

      try {
        let resp = await this.$store.dispatch("postWithdrawSmartpay", payload)
        await this.$store.dispatch("updateUsdtAccount")
        this.withdrawData = resp.data;
        if (resp.status == 200) {
          await this.$store.dispatch("updateUsdtAccount")
          this.step = 6;
        } else {
          this.step = 9;
        }
      } catch (e) {
        let res = String(e).split(":");
        this.error = res[1];
        this.step = 9;
      }
    },

    resetRedeem() {
      this.step = 3;
      this.previewData = "";
    },
    callStepSelect(amount) {
      this.withdraw.amount = parseFloat(amount);
      this.step = 3;
    },
    backToPartners() {
      this.step = 3;
    },
    callStepConfirmation(partner) {
      this.selectedPartner = partner;
      this.step = 3;
    },
    async callStepPreview(amount, address, externalId) {
      console.log(amount, address, externalId, "??????");
      this.address = address;
      this.externalId = externalId;

      this.withdraw.amount = parseFloat(amount);
      this.withdraw.address = address;
      this.withdraw.externalId = externalId;

      if (!this.selectedBlue) {
        this.withdraw.currency = "USDT";
      }

      // console.log(this.withdraw, "postWithdrawPreview");

      try {
        let resp = await this.$store.dispatch(
          "postWithdrawPreview",
          this.withdraw
        );
        this.previewData = resp.data;
        this.step = 4;
      } catch (e) {
        console.log(e);
      }
    },

    async callStepWithdraw(params) {
      this.addressToSend = params.address;
      this.amountToSend = params.amount - 2;
      if (this.selectedBlue) {
        console.log(params, "postWithdraw");
        try {
          let resp = await this.$store
            .dispatch("postWithdraw", params)
            .then(this.$store.dispatch("updateBluAccount"));
          this.withdrawData = resp.data;
          if (resp.status == 200) {
            this.step = 5;
            this.notifySuccess(
              this.$t("msg.check_your_email_for_pin_redeem"),
              5000
            );
          } else {
            this.step = 9;
          }
        } catch (e) {
          let res = String(e).split(":");

          this.error = res[1];
          this.step = 9;
        }
      } else {
        this.step = 5;
      }
    },

    async withdrawConfirm(withdraw) {
      let type = "withdraw";

      console.log(withdraw, "putWithdrawConfirm");
      try {
        let resp = await this.$store
          .dispatch("putWithdrawConfirm", withdraw)
          .then(this.$store.dispatch("updateBluAccount"));
        this.step = 6;
      } catch (e) {
        let error = String(e);
        let array = error.split(" ");
        let msgErro = "";

        array.shift();
        msgErro = array.join("_");

        this.notifyDanger(this.$t(`msg.${msgErro.toLowerCase()}`), 5000);
      }
    },

    setFirstStep() {
      this.step = 3;
    },

    async getOtpStatus() {
      let resp = await this.$store.dispatch("getOtpStatus");
      this.authorized = resp.data;
      this.$emit("updateOptStatus");
    },
    switchMode() {
      this.$emit("switchMode");
    },
  },
  computed: {
    ...mapGetters(["accounts", "usdtAccount"]),
  },
  watch: {
    withdraws: function () {
      this.checkRunningWithdraws();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/WithdrawMain.vue